import React, { FunctionComponent } from 'react';

import styles from './InstagramCardReportUi.module.scss';
import {
  BookmarkIcon,
  CommentTwitter,
  Ellipse_one,
  Ellipse_two,
  InstaShareIcon,
  LoveTwitter,
} from 'app/assets/images/icons';
import { nFormatter } from 'app/utils/numbersFormater';
import { _t } from 'app/utils/i18n';

interface Props {
  likes_count: number;
  comments_count: number;
  content: string;
  username: string;
}

const InstagramCardReportUi: FunctionComponent<Props> = ({
  comments_count,
  content,
  likes_count,
  username,
}) => {
  return (
    <div className={styles.InstagramCardReportUi}>
      <>
        <div
          className={`${styles.TwitterIconsBar}`}
          style={{
            display: 'flex',
            border: 'none',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <section style={{ display: 'flex', gap: '1rem' }}>
            <div>
              <LoveTwitter />
            </div>
            <div>
              <CommentTwitter />
            </div>
            <div>
              <InstaShareIcon />
            </div>
          </section>
          <span style={{ display: 'flex', gap: '0.5rem' }}>
            <Ellipse_two />
            <Ellipse_one />
            <Ellipse_two />
          </span>
          <div>
            <BookmarkIcon />
          </div>
        </div>
        <div
          style={{
            fontSize: '12px',
            fontWeight: 'bold',
            display: 'flex',
            gap: '0.25rem',
            textTransform: 'capitalize',
            margin: '0.3rem 0rem',
          }}
        >
          <span>{nFormatter(likes_count)}</span>
          <span>{_t('trends:likes')}</span>
        </div>

        <div className={styles.TweetContent}>
          <p className={`${styles.content} post_card_content`}>
            <span>@{username}</span>
            {content}
          </p>
        </div>
        <div style={{ fontSize: '10px'}}>
          <span>{`${_t('trends:view_all')} ${nFormatter(comments_count)} ${_t('trends:comments')}`}</span>
        </div>
      </>
    </div>
  );
};

export default InstagramCardReportUi;
